module.exports = __webpack_public_path__ + "img/product.4918e181.png";